import SceneLoader from './SceneLoaderClass';

// Initialize window variable for scene being loaded (for Puppeteer)
window.sceneLoaded = false;

// Use this as the primary scene loader instance
export default new SceneLoader();
